import HTTP from './common/http-common';

const END_POINT = '/authen';

const login = (userName, password) => HTTP.post(END_POINT + '/login', {userName, password}, { cache: false });
const logout = (userName) => HTTP.get(END_POINT + '/logout/' + userName, { cache: false });
const authen = () => HTTP.get(END_POINT, { cache: false });

export {
    login,
    logout,
    authen
}